export default __webpack_public_path__ + "d5e3e7ca29b2f52afaa96d3955432af6.png";